export { default } from './TitleTextMultiColumnImageTitleText';
